// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  width: 100%;
  height: 80px;
  background-color: #dde8b9;
  /* Stabiles 3-Spalten-Layout: Logo | Dropdown (mittig) | Map.
     Feste Spalten -> Elemente bleiben beim Navigieren an fixer Position. */
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 2rem;
  font-size: 1.2rem;
  position: relative;
  z-index: 10;
  margin-top: 1rem;
  box-sizing: border-box;
}

.logo {
  grid-column: 1;
  justify-self: start;
  align-self: start;
  cursor: pointer;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  cursor: pointer;
}


/* Bigger logo size for the start page */
.logo-img {
  height: 7rem;
  width: 16.5rem;
  object-fit: contain;
  display: block;
}

/* Default logo size for Unterseiten */
.logo-img-small {
  height: 4.5rem;
  width: 11rem;
}

.logo-spotlight {
  position: relative;
  isolation: isolate;
}

.logo-spotlight::after {
  content: "";
  position: absolute;
  inset: -15% -25%;
  background: radial-gradient(circle at 50% 40%, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0));
  opacity: 0.35;
  mix-blend-mode: screen;
  filter: blur(6px);
  pointer-events: none;
}

.logo-img-animate {
  animation: logoFloat 900ms cubic-bezier(0.2, 0.7, 0.2, 1) both;
  transform-origin: center;
}

.dropdown {
  grid-column: 2;
  justify-self: center;
  position: relative; /* anchor for the absolute dropdown-menu */
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 15;
  width: max-content;
}

.dropdown-toggle {
  cursor: pointer;
  font-weight: normal;
  color: #00507b;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  font-size: 1.2rem;
}

.dropdown-prefix {
  text-decoration: none;
  color: #00509E;
}

.dropdown-current {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.dropdown-label {
  text-decoration: underline;
  text-underline-offset: 4px;
  font-size: 1.2rem;
  color: #00509E;
}

.dropdown-icon {
  stroke: #00507b !important;
  color: #00507b !important;
  font-size: 1.2rem;
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #6DADD0;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 160px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 20;
}


.dropdown-menu li {
  padding: 0.5rem 0;
  cursor: pointer;
  color: #003b5b;
  width: 100%;
  text-align: center;
}

.dropdown-menu li:hover {
  background-color: #DDE8B9;
  color: #1f3b94;
  border-radius: 5px;
}

.dropdown-menu .active-item {
  background-color: #DDE8B9;
  font-weight: normal;
  border-radius: 5px;
}

.dropdown-menu li.active-item {
  background-color: #dde8b9;
  font-weight: normal;
  color: #1f3b94;
}

.nav-icon {
  color: #00507b;
  cursor: pointer;
}

/* Map link styling */
.map-link {
  grid-column: 3;
  justify-self: end;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  cursor: pointer;
}

.map-label {
  color: #00509E;
  font-size: 1.2rem;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.map-icon {
  font-size: 1.8rem;
  stroke: var(--mittelblau);
  color: var(--mittelblau);
}


.hamburger {
  display: none;
  cursor: pointer;
  color: var(--mittelblau);
  font-size: 2rem;
}

.hamburger-icon {
  pointer-events: none;
  color: var(--mittelblau);
  transition: transform 0.3s ease;
}

.hamburger-icon.open {
  transform: rotate(90deg);
}

@media (max-width: 600px) {
  .navbar {
    flex-direction: row;
    align-items: center;
    height: 60px;
    padding: 0 1rem;
    gap: 1rem;
  }

  .logo-img {
    height: 3.5rem;
    width: auto;
  }

  .logo-img-small {
    height: 3rem;
    width: auto;
  }

  .dropdown-toggle {
    display: none;
  }

  .hamburger {
    display: block;
    position: static;
    transform: none;
    z-index: 25;
    /* keep menu above other elements */
  }

  .dropdown {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    align-items: center;
  }

  .dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    left: 50%;
    transform: translateX(-50%);
  }

  .map-link {
    margin-top: 0;
  }

  .map-label {
    display: none;
  }

  .map-icon {
    font-size: 2rem;
  }
}

@keyframes logoFloat {
  0% {
    opacity: 0;
    transform: translateY(4px) scale(0.98);
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.16));
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.12));
  }
}

@media (prefers-reduced-motion: reduce) {
  .logo-spotlight::after,
  .logo-img-animate {
    animation: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/navbar/KernteamNavbar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB;2EACyE;EACzE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;;AAGA,wCAAwC;AACxC;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iGAAiG;EACjG,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,8DAA8D;EAC9D,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB,EAAE,0CAA0C;EAC9D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;AAC1B;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;IACtC,kDAAkD;EACpD;EACA;IACE,UAAU;IACV,iCAAiC;IACjC,kDAAkD;EACpD;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":[".navbar {\n  width: 100%;\n  height: 80px;\n  background-color: #dde8b9;\n  /* Stabiles 3-Spalten-Layout: Logo | Dropdown (mittig) | Map.\n     Feste Spalten -> Elemente bleiben beim Navigieren an fixer Position. */\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  padding: 0 2rem;\n  font-size: 1.2rem;\n  position: relative;\n  z-index: 10;\n  margin-top: 1rem;\n  box-sizing: border-box;\n}\n\n.logo {\n  grid-column: 1;\n  justify-self: start;\n  align-self: start;\n  cursor: pointer;\n}\n\n.logo-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n}\n\n\n/* Bigger logo size for the start page */\n.logo-img {\n  height: 7rem;\n  width: 16.5rem;\n  object-fit: contain;\n  display: block;\n}\n\n/* Default logo size for Unterseiten */\n.logo-img-small {\n  height: 4.5rem;\n  width: 11rem;\n}\n\n.logo-spotlight {\n  position: relative;\n  isolation: isolate;\n}\n\n.logo-spotlight::after {\n  content: \"\";\n  position: absolute;\n  inset: -15% -25%;\n  background: radial-gradient(circle at 50% 40%, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0));\n  opacity: 0.35;\n  mix-blend-mode: screen;\n  filter: blur(6px);\n  pointer-events: none;\n}\n\n.logo-img-animate {\n  animation: logoFloat 900ms cubic-bezier(0.2, 0.7, 0.2, 1) both;\n  transform-origin: center;\n}\n\n.dropdown {\n  grid-column: 2;\n  justify-self: center;\n  position: relative; /* anchor for the absolute dropdown-menu */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 15;\n  width: max-content;\n}\n\n.dropdown-toggle {\n  cursor: pointer;\n  font-weight: normal;\n  color: #00507b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  font-size: 1.2rem;\n}\n\n.dropdown-prefix {\n  text-decoration: none;\n  color: #00509E;\n}\n\n.dropdown-current {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.dropdown-label {\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  font-size: 1.2rem;\n  color: #00509E;\n}\n\n.dropdown-icon {\n  stroke: #00507b !important;\n  color: #00507b !important;\n  font-size: 1.2rem;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #6DADD0;\n  padding: 0.5rem 1rem;\n  border-radius: 10px;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 160px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 20;\n}\n\n\n.dropdown-menu li {\n  padding: 0.5rem 0;\n  cursor: pointer;\n  color: #003b5b;\n  width: 100%;\n  text-align: center;\n}\n\n.dropdown-menu li:hover {\n  background-color: #DDE8B9;\n  color: #1f3b94;\n  border-radius: 5px;\n}\n\n.dropdown-menu .active-item {\n  background-color: #DDE8B9;\n  font-weight: normal;\n  border-radius: 5px;\n}\n\n.dropdown-menu li.active-item {\n  background-color: #dde8b9;\n  font-weight: normal;\n  color: #1f3b94;\n}\n\n.nav-icon {\n  color: #00507b;\n  cursor: pointer;\n}\n\n/* Map link styling */\n.map-link {\n  grid-column: 3;\n  justify-self: end;\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  cursor: pointer;\n}\n\n.map-label {\n  color: #00509E;\n  font-size: 1.2rem;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.map-icon {\n  font-size: 1.8rem;\n  stroke: var(--mittelblau);\n  color: var(--mittelblau);\n}\n\n\n.hamburger {\n  display: none;\n  cursor: pointer;\n  color: var(--mittelblau);\n  font-size: 2rem;\n}\n\n.hamburger-icon {\n  pointer-events: none;\n  color: var(--mittelblau);\n  transition: transform 0.3s ease;\n}\n\n.hamburger-icon.open {\n  transform: rotate(90deg);\n}\n\n@media (max-width: 600px) {\n  .navbar {\n    flex-direction: row;\n    align-items: center;\n    height: 60px;\n    padding: 0 1rem;\n    gap: 1rem;\n  }\n\n  .logo-img {\n    height: 3.5rem;\n    width: auto;\n  }\n\n  .logo-img-small {\n    height: 3rem;\n    width: auto;\n  }\n\n  .dropdown-toggle {\n    display: none;\n  }\n\n  .hamburger {\n    display: block;\n    position: static;\n    transform: none;\n    z-index: 25;\n    /* keep menu above other elements */\n  }\n\n  .dropdown {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    align-items: center;\n  }\n\n  .dropdown-menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  .map-link {\n    margin-top: 0;\n  }\n\n  .map-label {\n    display: none;\n  }\n\n  .map-icon {\n    font-size: 2rem;\n  }\n}\n\n@keyframes logoFloat {\n  0% {\n    opacity: 0;\n    transform: translateY(4px) scale(0.98);\n    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.16));\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n    filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.12));\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .logo-spotlight::after,\n  .logo-img-animate {\n    animation: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
